import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router } from '@angular/router';
import { EMPTY, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SeriesService, Series } from 'cms-post-lib';
import { environment } from '../../../environments/environment';

export interface SeriesDetailResolvedData {
  series: Series | null;
}

export const seriesDetailResolver: ResolveFn<SeriesDetailResolvedData> = (route: ActivatedRouteSnapshot) => {
  const seriesService = inject(SeriesService);
  const router = inject(Router);
  const slug = route.paramMap.get('slug') ?? '';
  const orgId = environment.orgId;

  return seriesService.getPublicSeriesBySlug(slug, orgId).pipe(
    map(res => ({ series: res.data ?? null })),
    catchError(() => {
      router.navigate(['/series']);
      return EMPTY;
    })
  );
};
